module.exports = __webpack_public_path__ + "static/media/vegitables_67.9e3d3e2f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_67.csv
// module id = 654
// module chunks = 0